export default __webpack_public_path__ + "static/media/hide.5d57a93a.svg";